import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "itemHeading",
    "itemSubheading",
    "hiddenInput",
    "itemDisplay",
    "container",
    "confirmedBadge",
    "changeButton",
    "selectionButtons",
  ];
  static values = {
    items: Array,
    currentIndex: Number,
  };

  connect() {
    this.updateDisplay();
  }

  chooseAnother() {
    this.currentIndexValue =
      (this.currentIndexValue + 1) % this.itemsValue.length;
    this.updateDisplay();
  }

  changeItem() {
    this.currentIndexValue =
      (this.currentIndexValue + 1) % this.itemsValue.length;
    this.updateDisplay();

    this.containerTarget.classList.remove("border-success");
    this.containerTarget.classList.add("border-primary");

    this.confirmedBadgeTarget.classList.add("hidden");
    this.changeButtonTarget.classList.add("hidden");
    this.selectionButtonsTarget.classList.remove("hidden");
    this.selectionButtonsTarget.classList.add("flex", "gap-4");
  }

  updateDisplay() {
    if (this.itemsValue.length === 0) {
      this.itemHeadingTarget.textContent = "No options available";
      this.itemSubheadingTarget.textContent = "";
      this.hiddenInputTarget.value = "";
      return;
    }

    const currentItem = this.itemsValue[this.currentIndexValue];

    this.itemHeadingTarget.textContent = currentItem.heading;
    this.itemSubheadingTarget.textContent = currentItem.subheading;
    this.hiddenInputTarget.value = currentItem.value;
  }
}
